import React from "react";

const BannerSection = () => {
  return (
    <section className="banner-section">
      <div className="container">
        <div className="section-wrapper">
          <div className="row align-items-end content">
            <div className="quotes">
              Janakyah Kamalamalanjali Puteyah Padmaragayitah Nyastaraghava
              Mastakecha Vilasatkundaprasunayitah Srastha
              Syaamalakayakantikalita Yaayindra Neelaayitaah Muktaastasshubhada
              Bhavantu Bhavataam Sriramavaivaahikaah
            </div>
            <div className="connect">
              {/* <div className="userclick my-self">
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio1"
                    value="option1"
                  />
                  <label className="form-check-label" htmlFor="inlineRadio1">
                    Myself
                  </label>
                </div>
              </div>
              <div className="userclick family-friends">
                <div className="form-check form-check-inline">
                  <input
                    className="form-check-input"
                    type="radio"
                    name="inlineRadioOptions"
                    id="inlineRadio2"
                    value="option2"
                  />
                  <label className="form-check-label" htmlFor="inlineRadio2">
                    Family or Friend
                  </label>
                </div>
              </div>
              <div className="userclick lets-connect">LET'S CONNECT</div> */}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BannerSection;
